<template>
  <div class="page">
    <div class="box">
      <van-field
        readonly
        clickable
        label-width="0"
        :value="areaName"
        placeholder="请选择店铺所在地区"
        @click="showPicker = true"
      >
        <template #button>
          <van-icon name="arrow" />
        </template>
      </van-field>
      <van-overlay :show="showPicker" @click="showPicker = false">
        <van-area class="picker" v-show="showPicker" :value="params.storeProvince" title="选择地址" :area-list="areaList" @confirm="changeArea" @cancel="showPicker = false" />
      </van-overlay>
      <van-search v-model="params.storeName" placeholder="请输入搜索关键词" background="#ffffff" @search="onSearch" />
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      :finished.sync="finished"
      finished-text="已经见底啦~"
      error-text="请求失败，点击重新加载"
      @load="loadList"
      class="list">
      <div class="store-item" v-for="(item,index) in list" v-bind:key="index" @click="toReceive(item)">
        <van-image
          class="store-img"
          fit="cover"
          :src="item.storeIcon"
        />
        <div class="store-col">
          <div class="name">
            {{item.storeName}}
          </div>
          <div class="address">
            {{item.storeProvinceValue}}{{item.storeCityValue}}{{item.storeRegionValue}}{{item.storeDetailAddress}}
          </div>
        </div>
      </div>
    </van-list>
    <div class="nodata-warp" v-if="list.length === 0">
      <img src="@/assets/images/common/noData.png"  class="img" alt="" />
      <div class="tips">
        未查询到该店铺
      </div>
    </div>
    <div class="createStore"  @click="csStoreDialog = true">
      没有您的店铺？<span style="color:#259CEB">点击创建</span>
    </div>
    <van-overlay :show="csStoreDialog" >
      <div class="dialog-wrap">
        <div class="cs-dialog">
          <img src="@/assets/images/common/qrCode.png"  class="img" alt="" />
          <div class="cs-sub">请长按识别，创建我的店铺</div>
          <div class="van-icon van-icon-cross dialog-close" @click="csStoreDialog = false"></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import arealist from '@/assets/js/Area.js'

export default {
  data () {
    return {
      csStoreDialog: false,
      params: {
        storeName: '',
        storeProvince: '',
        storeCity: '',
        storeRegion: '',
        pageSize: 10,
        pageNum: 1
      },
      list: [],
      loading: false,
      error: false,
      finished: false,
      areaList: arealist,
      showPicker: false,
      areaName: ''
    }
  },
  created () {
    this.params.storeProvince = localStorage.getItem('activityProvince') || ''
    this.params.storeCity = localStorage.getItem('activityCity') || ''
    this.params.storeRegion = localStorage.getItem('activityRegion') || ''
    this.areaName = (this.params.storeProvince ? `${arealist.province_list[this.params.storeProvince]} ` : '')
                    + (this.params.storeCity ? `${arealist.city_list[this.params.storeCity]} ` : '')
                    + (this.params.storeRegion ? `${arealist.county_list[this.params.storeRegion] }` : '')
  },
  methods: {
    toReceive (item) {
      this.$router.push({
        path: '/store/receive',
        query: { id: item.voteActivityUncertifiedStoreId,type: '2' }
      })
    },
    onSearch () {
      this.params.pageNum = 1
      this.list = []
      this.loadList()
    },
    changeArea (e) {
      this.params.storeProvince = e[0].code
      this.params.storeCity = e[1].code
      this.params.storeRegion = e[2].code
      this.areaName = `${e[0].name} ${e[1].name} ${e[2].name}`
      this.showPicker = false
      this.onSearch()
    },
    loadList () {
      this.$api.activity.getUncertifiedStoreList(this.params).then(res => {
        if (res.data.list.length < this.params.pageSize) {
          this.finished = true
        }
        else {
          this.finished = false
        }
        this.list = [...this.list, ...res.data.list]
        this.params.pageNum++
        this.loading = false
        console.log(this.loading,this.finished)
      })
    }
  }
}
</script>
<style lang="less" scoped>

  @import "~@/assets/css/var.less";

  .page{
    box-sizing: border-box;
    padding-top: 20px;
  }
  .tit{
    box-sizing: border-box;
    font-size: 12px;
    color: #9A9A9A;
    display: flex;
    padding: 0 31px;
    margin: 20px 0 10px;
  }
  .box{
    width: 92%;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 0 auto;
  }
  .foot-btn{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 375px;
    height: 49px;
    background: #FF9A32;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    color: #FFFFFF;
  }
  .van-search__content{
    background-color: #ffffff;
  }
  .van-search{
    padding: 0.04rem 0rem;
  }
  .picker{
    position: fixed;
    z-index: 9;
    bottom: 0;
    left: 0;
    right: 0;
    touch-action: none;
  }
  .list{
    box-sizing: border-box;
    width: 92%;
    background: #FFFFFF;
    border-radius: 5px;
    padding: 0 15px;
    margin: 0 auto;
    margin-top: 11px;
  }
  .store-item{
    width: 100%;
    height: 74px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eeeeee;
  }
  .store-img{
    width: 50px;
    height: 50px;
    border-radius: 5px;
  }
  .store-col{
    width: 255px;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    .name{
      font-size: 13px;
      font-weight: bold;
      color: #333333;
    }
    .address{
      font-size: 12px;
      color: #999999;
      margin-top: 8px;
    }
  }
  .createStore{
    display: flex;
    padding: 20px 0;
    justify-content: center;
    font-size: 12px;
    color: #9A9A9A;
  }
  .dialog-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    .dialog-close{
      position: absolute;
      right: 15px;
      top:15px;
      width: 23px;
      height: 23px;
      font-size: 23px;
      line-height: 23px;
      text-align: center;
      color: #CDCDCD;
    }

    .cs-dialog{
      background-color: #fff;
      border-radius: 5px;
      width: 275px;
      padding:  30px 0;
      position: relative;

      .cs-title{
        font-size: 16px;
        color: #333;
        text-align: center;
      }

      .img{
        height: 159px;
        width: 159px;
        display: block;
        margin: 17px auto 0 auto;
      }

      .cs-sub{
        font-size: 10px;
        color: #999;
        line-height: 1;
        padding-top: 10px;
        text-align: center;
      }
    }
    .post-dialog{
       &>.img{
         width: 275px;
         height: 374px;
         display: block;
       }
      &>.btn-close{
         width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 23px auto;
        .iconfont{
           font-size: 32px;
           color: #fff;
        }
      }
    }
  }
  .nodata-warp{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    img{
      width: 155px;
      height: 123px;
    }
    .tips{
      font-size: 12px;
      color: #9A9A9A;
      margin-top: 18px;
    }
  }
</style>
